/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeKpiSampleDto
 */
export interface InitiativeKpiSampleDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    kpiDefId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeKpiSampleDto
     */
    sampledAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof InitiativeKpiSampleDto
     */
    numericValue?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    textValue?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    sourceRef?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiativeKpiSampleDto
     */
    aiGenerated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeKpiSampleDto
     */
    humanReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiSampleDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeKpiSampleDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the InitiativeKpiSampleDto interface.
 */
export function instanceOfInitiativeKpiSampleDto(value: object): value is InitiativeKpiSampleDto {
    return true;
}

export function InitiativeKpiSampleDtoFromJSON(json: any): InitiativeKpiSampleDto {
    return InitiativeKpiSampleDtoFromJSONTyped(json, false);
}

export function InitiativeKpiSampleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeKpiSampleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'kpiDefId': json['kpiDefId'] == null ? undefined : json['kpiDefId'],
        'sampledAt': json['sampledAt'] == null ? undefined : (new Date(json['sampledAt'])),
        'numericValue': json['numericValue'] == null ? undefined : json['numericValue'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'aiGenerated': json['aiGenerated'] == null ? undefined : json['aiGenerated'],
        'humanReviewedAt': json['humanReviewedAt'] == null ? undefined : (new Date(json['humanReviewedAt'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function InitiativeKpiSampleDtoToJSON(json: any): InitiativeKpiSampleDto {
    return InitiativeKpiSampleDtoToJSONTyped(json, false);
}

export function InitiativeKpiSampleDtoToJSONTyped(value?: InitiativeKpiSampleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'kpiDefId': value['kpiDefId'],
        'sampledAt': value['sampledAt'] == null ? undefined : ((value['sampledAt']).toISOString()),
        'numericValue': value['numericValue'],
        'textValue': value['textValue'],
        'source': value['source'],
        'sourceRef': value['sourceRef'],
        'aiGenerated': value['aiGenerated'],
        'humanReviewedAt': value['humanReviewedAt'] == null ? undefined : ((value['humanReviewedAt']).toISOString()),
        'notes': value['notes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

